<div class="global-search-inspire-cta">
    <div class="tapestry-body body--md bold">
        {{
            'searchResults.personPeekPanel-inspireCtaTitle'
                | translateFormat: [firstName]
        }}
    </div>
    <div class="global-search-inspire-cta--body-container">
        <img
            alt="Inspire logo"
            class="global-search-inspire-cta--image"
            src="/platformAssets/globalSearch/inspire-cta.svg"
        />
        <div class="global-search-inspire-cta--body">
            <div
                class="global-search-inspire-cta--body-text"
                [innerHTML]="
                    'searchResults.personPeekPanel-inspireCtaDescription'
                        | translateFormat: [firstName]
                "
            ></div>
            <tapestry-button
                [text]="
                    (showInviteButton
                        ? 'searchResults.personPeekPanel-inspireCtaInviteButtonText'
                        : 'searchResults.personPeekPanel-inspireCtaButtonText'
                    ) | translateFormat: [firstName]
                "
                (buttonClicked)="primaryButtonClicked()"
            ></tapestry-button>
        </div>
    </div>
</div>
